import React, { useState } from "react";
import SideMenu, { SideMenuLink } from "@amzn/meridian/side-menu";
import {
  useSideMenuContext,
  useEligibilityContext,
  ELIGIBILITY_STATUS,
  useProcessPathPairsContext,
} from "../..";
import { useNavigate } from "react-router-dom";
import { POLICY, ELIGIBLE_PRODUCT, HOME } from "../../constants/paths";
import { useBundle } from "@amzn/react-arb-tools";
import { HOMEPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const AllegroSideMenu = () => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);
  const [link, setLink] = useState(HOME);
  const { sideMenuOpen } = useSideMenuContext();
  const { hasConfirmedEligibility } = useEligibilityContext();
  const { processPathPairs } = useProcessPathPairsContext();
  const isSiteEligible = processPathPairs.length !== 0;
  const navigate = useNavigate();
  const handleSideMenuClick = (path) => {
    setLink(path);
    navigate(path);
  };

  return (
    <SideMenu
      backgroundColor="secondary"
      maxWidth={"20vw"}
      minWidth={"120px"}
      open={sideMenuOpen}
    >
      <SideMenuLink
        selected={link === HOME}
        onClick={() => handleSideMenuClick(HOME)}
      >
        {t(bundle, "home")}
      </SideMenuLink>
      {hasConfirmedEligibility === ELIGIBILITY_STATUS.YES && (
        <SideMenuLink
          selected={link === ELIGIBLE_PRODUCT}
          onClick={() => handleSideMenuClick(ELIGIBLE_PRODUCT)}
        >
          {t(bundle, "eligible_products")}
        </SideMenuLink>
      )}
      {isSiteEligible && (
        <SideMenuLink
          selected={link === POLICY}
          onClick={() => handleSideMenuClick(POLICY)}
        >
          {t(bundle, "policy")}
        </SideMenuLink>
      )}
    </SideMenu>
  );
};

export default AllegroSideMenu;
